// ENUMS for on boarding at Backend
export const ON_BOARDING_ENUMS = {
  CAMPAIGNS_AND_EMAILS: "campaigns_and_emails",
  CAMPAIGNS: "campaigns",
  CAMPAIGNS_SMARTSOURCE: "campaigns_smart_source",
  ASSETS: "assets",
  ASSETS_SMARTSOURCE: "asset_smart_source",
  ASSETS_STEP: "asset_step",
  EDITIONS: "editions",
  EDITIONS_SMARTSOURCE: "edition_smart_source",
  CONTENT_EXPLORER: "content_explorer",
  CONTENT_ASSET_BROWSER: "content_asset_browser",
  CAMPAIGNS_AUDIENCE: "campaign_audience",
  CAMPAIGNS_AUDIENCE_DASHBOARD: "campaign_audience_dashboard",
};

export const CAMPAIGNS_ASSETS_HOMEPAGE_ONBOARDING = {
  SHOW: "CAMPAIGNS_ASSETS_HOMEPAGE_ONBOARDING_SHOW",
  SET_STEP: "CAMPAIGNS_ASSETS_HOMEPAGE_ONBOARDING_SET_STEP",
};

export const CREATE_CAMPAIGN_TRY_IT_NOW_ONBOARDING = {
  SHOW: "CREATE_CAMPAIGN_TRY_IT_NOW_ONBOARDING_SHOW",
  SET_STEP: "CREATE_CAMPAIGN_TRY_IT_NOW_ONBOARDING_SET_STEP",
  HIDE: "CREATE_CAMPAIGN_TRY_IT_NOW_ONBOARDING_HIDE",
};

export const OPEN_CAMPAIGN_FIRST_TIME_ONBOARDING = {
  SHOW: "OPEN_CAMPAIGN_FIRST_TIME_ONBOARDING_SHOW",
  HIDE: "OPEN_CAMPAIGN_FIRST_TIME_ONBOARDING_HIDE",
};

// content explorer on boarding
export const CONTENT_EXPLORER_ONBOARDING = {
  SHOW: "CONTENT_EXPLORER_ONBOARDING_SHOW",
  SET_STEP: "CONTENT_EXPLORER_ONBOARDING_SET_STEP",
  SHOW_CHECKBOX_TRY_NOW: "CONTENT_EXPLORER_ONBOARDING_SHOW_CHECKBOX_TRY_NOW",
  HIDE_CHECKBOX_TRY_NOW: "CONTENT_EXPLORER_ONBOARDING_HIDE_CHECKBOX_TRY_NOW",
  SET_ID: "CONTENT_EXPLORER_ONBOARDING_SET_ID",
  // SET_STEP: "CONTENT_EXPLORER_ONBOARDING_SET_STEP",
};

export const CAMPAIGN_ON_BOARDING = {
  DASHBOARD_SET_STEP: "CAMPAIGN_ON_BOARDING_DASHBOARD_SET_STEP",
  SMART_SOURCE_SET_STEP: "CAMPAIGN_ON_BOARDING_SMART_SOURCE_SET_STEP",
  SMART_SOURCE_SET_UPDATE_KEYWORD: "CAMPAIGN_ON_BOARDING_SMART_SOURCE_SET_UPDATE_KEYWORD",
  AUDIENCE_SET_STEP: "CAMPAIGN_ON_BOARDING_AUDIENCE_SET_STEP",
  AUDIENCE_SET_SELECTED_LIST: "CAMPAIGN_ON_BOARDING_AUDIENCE_SET_SELECTED_LIST",
  AUDIENCE_SET_SHOW_LIST: "CAMPAIGN_ON_BOARDING_AUDIENCE_SET_SHOW_LIST",
};

export const EMAIL_BROWSER_ON_BOARDING = {
  SET_SHOW: "EMAIL_BROWSER_ON_BORADING_SET_SHOW",
};
